angular.module('unergie.main')
.directive('salesTunnelResidenceV3', (MetaWatcher) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        disableContractEdition: '=',
        disabled: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelResidenceV3.html',
    link($scope) {
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.form = {}
        // VALIDATORS
        const initComponentValidator = () =>
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isAMoveDefined(store) {
                    return _.isBoolean(store.draft.is_a_move)
                },
            })

        $scope.$watch('draft', (draft) => {
            $scope.form = {
                is_a_move: _.get(draft, 'is_a_move', undefined),
            }
        })

        const activate = initComponentValidator
        activate()
    },
}))
